'use strict';

import angular from 'angular';
import ListController from './list.controller';

export default angular.module('updateServerApp.tags.list', [])
  .controller('TagsListController', ListController)
  .name;



// WEBPACK FOOTER //
// ./client/app/tags/list/index.js